import './FooterSkeleton.scss';

const FooterSkeleton = () => {

    return (
        <footer className='footer__skeleton'>
            <div className='sitemap__wrapper__skeleton'>
                <div className='sitemap__company__item__skeleton'>
                    <div className='footer__company__logo__skeleton'>
                        <div className='link__logo__skeleton'></div>
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className='footer__company__text__skeleton'></div>
                        ))}
                        <div className='footer__company__text__skeleton--primary'></div>
                    </div>
                    <div className='footer__links__wrapper__skeleton'>
                        <div className="socials__item__skeleton">
                            {[...Array(4)].map((_, i) => (
                                <div key={i} className="socials__link__skeleton"></div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='sitemap__list__wrapper__skeleton'>
                    <div className='sitemap__list__item__skeleton'>
                        <div className='sitemap__list__item__subtitle__skeleton'></div>
                        {[...Array(7)].map((_, i) => (
                            <div key={i} className='nav__list__skeleton'></div>
                        ))}
                    </div>
                    <div className='sitemap__list__item__skeleton'>
                        <div className='sitemap__list__item__subtitle__skeleton'></div>
                        {[...Array(10)].map((_, i) => (
                            <div key={i} className='nav__list__skeleton'></div>
                        ))}
                    </div>
                    <div className='sitemap__list__item__skeleton'>
                        <div className='sitemap__list__item__subtitle__skeleton'></div>
                        {[...Array(8)].map((_, i) => (
                            <div key={i} className='nav__list__skeleton'></div>
                        ))}
                    </div>
                    <div className='sitemap__list__item__skeleton--primary'>
                        <div className='sitemap__list__item__subtitle__skeleton--primary'></div>
                        {[...Array(6)].map((_, i) => (
                            <div key={i} className='nav__list__skeleton--primary'></div>
                        ))}
                    </div>
                </div>
                <div className='sitemap__contact__wrapper__skeleton'>
                    <div className='recent__work__button__skeleton'></div>
                    <div className='sitemap__contact__item__subtitle__skeleton'></div>
                    <div className='sitemap__contact__item__adress__skeleton'></div>
                    <div className='phone__link__skeleton'></div>
                    <div className='email__link__skeleton'></div>
                </div>
            </div>
            <div className='reserved__skeleton'>
                <div className='reserved__text__skeleton'></div>
                <div className='reserved__links__item__wrapper__skeleton'>
                    <div className='reserved__links__item__skeleton'></div>
                    <div className='reserved__links__item__skeleton'></div>
                    <div className='reserved__links__item__skeleton'></div>
                </div>
            </div>
        </footer>
    );
};

export default FooterSkeleton;